export default __webpack_public_path__ + "static/media/640_business01-it-mobile.c37a5130.png";